import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingComponent} from "./loading.component";
import {LoadingComponent2} from "./loading.component2";


@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [LoadingComponent, LoadingComponent2],
    exports: [LoadingComponent, LoadingComponent2]
})
export class LoadingModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/autenticacion/loadingScreen/loading.module.ts